import { useEffect, useState } from "react";

/**
 * Current epoch milliseconds, re-read every second while `active`.
 *
 * Each tick reads the clock afresh rather than advancing a counter, so an
 * interval the browser throttles in a background tab resyncs on its next tick
 * instead of accumulating drift against the real elapsed time.
 */
export function useNowTicker(active: boolean): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [active]);

  return now;
}
